// extracted by mini-css-extract-plugin
module.exports = {"dialogDetail":"JobAlertDialogText_dialogDetail__TBMkS","dialogButton":"JobAlertDialogText_dialogButton__km2B2"};